export const layoutItems = ['chat', 'about', 'feedback', 'onboardingMode'] as const;

export type LayoutItem = (typeof layoutItems)[number];

export type LayoutProps = {
  translation: string;
  icon: string;
};

export type VariantConfig = {
  [key in LayoutItem]: LayoutProps;
};

export const sidebarToContent: VariantConfig = {
  chat: {
    translation: 'chatPage.sidebar.history.label',
    icon: 'icon-chat',
  },
  about: {
    translation: 'chatPage.sidebar.about.label',
    icon: 'icon-info',
  },
  feedback: {
    translation: 'chatPage.sidebar.feedback.label',
    icon: 'icon-send',
  },
  onboardingMode: {
    translation: 'chatPage.sidebar.onboardingMode.label',
    icon: 'icon-onboarding',
  },
} as const;
